import { ProductListParams } from '@graphcommerce/magento-product/components/ProductListItems/filterTypes'
import { useProductListParamsContext } from '@graphcommerce/magento-product/hooks/useProductListParamsContext'
import { useRouter } from 'next/router'
import { createProductListLink } from './useProductListLink'

type UseProductLinkPushProps = {
  shallow?: boolean
  locale?: string | false
  scroll?: boolean
}

export function useProductListLinkReplace(props?: UseProductLinkPushProps) {
  const { setParams } = useProductListParamsContext()
  const router = useRouter()

  return (params: ProductListParams) => {
    const queryUrl = router.query.url ?? []
    const comingFromURLWithoutFilters = !queryUrl.includes('q')

    setParams(params)

    const path = createProductListLink(params)

    // push the first filter, so the new route (on browser back) will be e.g. /women/fruit instead of /women
    if (comingFromURLWithoutFilters) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      router.push(path, path, props)
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      router.replace(path, path, props)
    }
  }
}
